var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('navbar'),_vm._v(" "),_c('banner',{attrs:{"routeName":_vm.routeName}}),_vm._v(" "),_c('detalle',{attrs:{"hotelData":_vm.hotelData}}),_vm._v(" "),_c('wcheckin'),_vm._v(" "),_c('my-footer'),_vm._v(" "),_c('whatsapp')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cc9041","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Checkin.vue
// module id = 689
// module chunks = 2